import openStreetMapApi from '~/api/openStreetMapApi';

/**
 *
 */
export const state = () => ({
    isOpen: false,
    contentComponent: null,
    contentExpandedComponent: null,
    backgroundComponent: null,
    restaurant: null,
    track: null,
    lift: null,
    railway: null,
    busline: null,
    poi: null,
    weatherStation: null,
});

export const mutations = {
    setRestaurant(state, payload) {
        state.restaurant = payload;
    },
    setTrack(state, payload) {
        state.track = payload;
    },
    setLift(state, payload) {
        state.lift = payload;
    },
    setRailway(state, payload) {
        state.railway = payload;
    },
    setBusline(state, payload) {
        state.busline = payload;
    },
    setPoi(state, payload) {
        state.poi = payload;
    },
    setWeatherStation(state, payload) {
        state.weatherStation = payload;
    },
    setContentComponent(state, payload) {
        state.contentComponent = payload;
    },
    setContentExpandedComponent(state, payload) {
        state.contentExpandedComponent = payload;
    },
    setBackgroundComponent(state, payload) {
        state.backgroundComponent = payload;
    },
    setIsOpen(state, flag) {
        state.isOpen = flag;
    },
    reset(state) {
        state.isOpen = false;
        state.contentComponent = null;
        state.contentExpandedComponent = null;
        state.backgroundComponent = null;
        state.restaurant = null;
        state.track = null;
        state.lift = null;
        state.railway = null;
        state.busline = null;
        state.poi = null;
        state.weatherStation = null;
    },
};

export const actions = {
    async openRestaurantFlyout({ state, commit }, restaurantId) {
        const restaurant = await openStreetMapApi.loadRestaurant(restaurantId);
        if (restaurant) {
            commit('setRestaurant', restaurant);
            commit('setContentComponent', 'ContentRestaurant');
            commit('setContentExpandedComponent', 'ContentRestaurantExpanded');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Icon', restaurant.name);
            return true;
        }
        return false;
    },

    async openLiftFlyout({ state, commit }, lift) {
        if (lift) {
            commit('setLift', lift);
            commit('setContentComponent', 'ContentLift');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Track', lift.name, { maps_status: lift.status });
            return true;
        }
        return false;
    },

    async openRailwayFlyout({ state, commit }, railway) {
        if (railway) {
            commit('setRailway', railway);
            commit('setContentComponent', 'ContentRailway');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Track', railway.name, { maps_status: railway.status });
            return true;
        }
        return false;
    },

    async openBuslineFlyout({ state, commit }, busline) {
        if (busline) {
            commit('setBusline', busline);
            commit('setContentComponent', 'ContentBusline');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Track', busline.name, { maps_status: busline.status });
            return true;
        }
        return false;
    },

    async openTrackFlyout({ state, commit }, track) {
        if (track) {
            commit('setTrack', track);
            commit('setContentComponent', 'ContentTrack');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Track', track.name, { maps_status: track.status });
            return true;
        }
        return false;
    },

    async openPoiFlyout({ state, commit }, poi) {
        if (poi) {
            commit('setPoi', poi);
            commit('setContentComponent', 'ContentPoi');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Icon', poi.nameDe);
            return true;
        }
        return false;
    },

    async openLiveDataFlyout({ state, commit }) {
        commit('setContentComponent', 'ContentLiveData');
        commit('setIsOpen', true);
        if (this.$gtm) this.$gtm.pushEvent('Click - Live Data', 'Live Daten');
        return true;
    },

    async openWeatherStationFlyout({ state, commit }, weatherStation) {
        if (weatherStation) {
            commit('setWeatherStation', weatherStation);
            commit('setContentComponent', 'ContentWeatherStation');
            commit('setBackgroundComponent', 'BackgroundWeatherStation');
            commit('setIsOpen', true);
            if (this.$gtm) this.$gtm.pushEvent('Click - Webcam', weatherStation.location.name);
            return true;
        }
        return false;
    },

    async closeFlyout({ state, commit }) {
        commit('reset');

        try {
            // Take all query parameters except "focus" and re-apply it to the route (meaning -> remove focus query parameter)
            // eslint-disable-next-line
            const { focus, ...query } = { ...this.app.router.history.current.query };
            await this.$router.replace({ query: { ...query, focus: undefined } });
        } catch (error) {
            // Catching replacing same query, which would throw an error but is fine
        }

    },
};
